/* The site shows the character module's game terms as its own term links (tooltip, link to the rules). */
import { setTermRenderer } from './character/Term';
import { TermLink } from './components/TermLink';

setTermRenderer((term) => <TermLink>{term}</TermLink>);
